/*
 * TFMC — us versus them, the switch.
 *
 * v4's UvtSwitchD/UvtSwitchM hold one boolean and re-render the whole ledger
 * from it. Here the two sides are both in the markup and CSS shows one of
 * them, so this file's whole job is the boolean: a class on the section root,
 * and the ARIA that tells a screen reader which side is showing.
 *
 * WHY THAT SPLIT. With this file blocked or slow, the panel still draws the
 * Animate side — the substance of the section — instead of a blank ledger.
 * Nothing here writes copy into the page; it only toggles which half is
 * displayed.
 *
 * The three rules assets/tfmc-motion.js follows, for the same reasons:
 *   - Page-level listeners bound ONCE at module scope, walking the document.
 *     `shopify:section:load` replaces the markup on every editor edit, so a
 *     listener bound inside a per-element wire() accumulates one copy per edit
 *     and its closure keeps the detached node alive.
 *   - Nothing is cached across a resize; the panel changes shape at 750px.
 *   - Nothing here touches, reads or writes the Loop widget.
 *
 * Keyboard: the pair is one tab stop with a roving tabindex, and Left/Right,
 * Home and End move between them — the WAI-ARIA tabs pattern. Selection
 * follows focus, which is correct here because switching is instant and
 * lossless.
 */
(function () {
  if (window.__tfmcSecUvt) return;
  window.__tfmcSecUvt = true;

  function wire(root) {
    if (!root || root.dataset.uvtWired === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-uvt-tab]'));
    var panel = root.querySelector('[data-uvt-ledger]');
    if (tabs.length !== 2 || !panel) return;
    root.dataset.uvtWired = 'true';

    function select(side, focus) {
      root.classList.toggle('is-them', side === 'them');
      // THE IDLE NUDGE STOPS ON FIRST USE. Desktop v5 and Ship v3 hold a
      // `touched` state in UvtTabs and drop the .uvt-tab--idle class from both
      // buttons the moment either is clicked; the animation exists to say the
      // switch is a switch, and once the visitor has used it the point is made.
      // Dropped from BOTH tabs, not just the one pressed, exactly as the
      // bundle's `active || touched` test does.
      for (var j = 0; j < tabs.length; j++) tabs[j].classList.remove('uvt-tab--idle');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-uvt-tab') === side;
        tabs[i].classList.toggle('is-on', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
        // The panel is labelled by whichever tab is selected, so the side being
        // shown is announced when focus moves into it.
        if (on) {
          panel.setAttribute('aria-labelledby', tabs[i].id);
          if (focus) tabs[i].focus();
        }
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t.getAttribute('data-uvt-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
        e.preventDefault();
        var i = tabs.indexOf(t);
        var next = k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : (i + (k === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[next].getAttribute('data-uvt-tab'), true);
      });
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-tfmc-uvt]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
